import React from 'react'
import ButtonLink, { ButtonLinkProps } from 'components/shared/ButtonLink'
import { RoutePath } from 'constants/RoutePath'

const AllBenefitsButton: React.FC<Omit<ButtonLinkProps, 'text' | 'to'>> = ({ ...props }) => {
  return <ButtonLink variant='outlined' text='All Benefits' to={RoutePath.BenefitsList} size='large' bold {...props} />
}

export default AllBenefitsButton
